const isMobile = () => window.innerWidth < 768;
const isTablet = () => window.innerWidth >= 768 && window.innerWidth < 992;
const isDesktop = () => window.innerWidth >= 992;

export const fadeInOnScroll = () => {
	const selectorsToObserve = ['.js-fade-up', '.js-fade-left', '.js-fade-right', '.js-fade-in'];

	if (useFadeInEffects()) {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					// Add class to elements when they enter the viewport
					entry.target.classList.add('is-intersecting');
				}
			});
		});

		selectorsToObserve.forEach((selector) => {
			const selectors = document.querySelectorAll(selector);
			selectors.forEach((selector) => observer.observe(selector));
		});
	} else {
		// If intersection observer not supported, just show everything on page load
		selectorsToObserve.forEach((selector) => {
			const selectors = document.querySelectorAll(selector);
			selectors.forEach((selector) => selector.classList.add('is-intersecting'));
		});
	}
};

const useFadeInEffects = () => !!window.IntersectionObserver && !isMobile();